/* DoxNetwork · JS de las secciones de venta. Vanilla, sin librerías.
   Cada init sale si su elemento no está en la página. */
(function () {
  'use strict';

  var reducir = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function formatear(centavos, moneda) {
    var n = Math.round(centavos / 100);
    return (moneda || '$') + String(n).replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  }

  /* Aparición al entrar en pantalla (lo mismo que dn-scripts, por si esta página no lo carga). */
  function initReveals() {
    var nodos = document.querySelectorAll('.dn-reveal:not(.dn-visible)');
    if (!nodos.length) return;
    if (!('IntersectionObserver' in window) || reducir) { nodos.forEach(function (n) { n.classList.add('dn-visible'); }); return; }
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('dn-visible'); io.unobserve(e.target); } });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    nodos.forEach(function (n) { io.observe(n); });
  }

  /* Galería deslizable: flechas, contador y miniaturas; ir(i) salta a una foto. */
  function initCarrusel(raiz) {
    var pista = raiz.querySelector('[data-dn-pista]');
    if (!pista) return null;
    var fotos = pista.querySelectorAll('[data-dn-foto]');
    var minis = raiz.querySelectorAll('[data-dn-mini]');
    var contador = raiz.querySelector('[data-dn-contador]');
    var actual = 0;
    function ir(i) {
      if (!fotos.length) return;
      i = (i + fotos.length) % fotos.length;
      var f = fotos[i];
      pista.scrollTo({ left: f.offsetLeft - pista.offsetLeft, behavior: reducir ? 'auto' : 'smooth' });
      marcar(i);
    }
    function marcar(i) {
      if (typeof i !== 'number') i = Math.round(pista.scrollLeft / Math.max(1, pista.clientWidth));
      actual = Math.max(0, Math.min(fotos.length - 1, i));
      if (contador) contador.textContent = (actual + 1) + ' / ' + fotos.length;
      minis.forEach(function (m, j) {
        var on = j === actual;
        m.classList.toggle('activa', on);
        if (on && m.parentNode && m.parentNode.scrollTo) {
          var p = m.parentNode;
          p.scrollTo({ left: m.offsetLeft - p.clientWidth / 2 + m.clientWidth / 2, behavior: reducir ? 'auto' : 'smooth' });
        }
      });
    }
    var prev = raiz.querySelector('[data-dn-prev]');
    var next = raiz.querySelector('[data-dn-next]');
    if (prev) prev.addEventListener('click', function () { ir(actual - 1); });
    if (next) next.addEventListener('click', function () { ir(actual + 1); });
    minis.forEach(function (m) { m.addEventListener('click', function () { ir(parseInt(m.getAttribute('data-dn-mini'), 10) || 0); }); });
    pista.setAttribute('tabindex', '0');
    pista.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') { e.preventDefault(); ir(actual - 1); }
      if (e.key === 'ArrowRight') { e.preventDefault(); ir(actual + 1); }
    });
    var t = null;
    pista.addEventListener('scroll', function () { clearTimeout(t); t = setTimeout(function () { marcar(); }, 80); }, { passive: true });
    marcar(0);
    return { ir: ir, fotos: fotos };
  }

  /* Oferta: color → variante; paquete → cantidad; precio total; barra fija; entrega estimada. */
  function initOferta() {
    document.querySelectorAll('[data-dn-oferta]').forEach(function (raiz) {
      var moneda = raiz.getAttribute('data-dn-moneda') || '$';
      var datos = raiz.querySelector('[data-dn-variantes]');
      var form = raiz.querySelector('form[data-dn-form]');
      if (!form) return;
      var variantes = [];
      try { variantes = JSON.parse(datos.textContent); } catch (e) { /* sin variantes */ }
      var inputId = form.querySelector('input[name="id"]');
      var inputCant = form.querySelector('[data-dn-cantidad]');
      var boton = form.querySelector('[data-dn-comprar]');
      var total = raiz.querySelector('[data-dn-total]');
      var totalBarra = raiz.querySelector('[data-dn-total-barra]');
      var botonBarra = raiz.querySelector('.dn-barra button');
      var carrusel = initCarrusel(raiz);
      var actual = variantes.find(function (v) { return String(v.id) === String(inputId && inputId.value); }) || variantes[0];

      function pack() {
        var p = raiz.querySelector('[data-dn-packs] input:checked');
        return { cant: p ? parseInt(p.value, 10) || 1 : 1, desc: p ? parseInt(p.getAttribute('data-dn-descuento'), 10) || 0 : 0 };
      }
      var antes = raiz.querySelector('[data-dn-antes]');
      var ahorro = raiz.querySelector('[data-dn-ahorro]');
      function pintar() {
        if (!actual) return;
        var p = pack();
        var t = actual.price * p.cant - p.desc;
        if (inputCant) inputCant.value = p.cant;
        if (total) total.textContent = formatear(t, moneda);
        if (totalBarra) totalBarra.textContent = formatear(t, moneda);
        /* Tachado honesto: solo con un pack con descuento, y lo tachado es lo que costarían esas unidades sueltas. */
        if (antes) { antes.hidden = !(p.desc > 0); antes.textContent = p.desc > 0 ? formatear(actual.price * p.cant, moneda) : ''; }
        if (ahorro) { ahorro.hidden = !(p.desc > 0); ahorro.textContent = p.desc > 0 ? 'Ahorras ' + formatear(p.desc, moneda) : ''; }
        raiz.querySelectorAll('[data-dn-packs] input').forEach(function (i) {
          var cant = parseInt(i.value, 10) || 1;
          var s = i.parentNode.querySelector('[data-dn-pack-precio]');
          if (s) s.textContent = formatear(actual.price * cant - (parseInt(i.getAttribute('data-dn-descuento'), 10) || 0), moneda);
          var s0 = i.parentNode.querySelector('[data-dn-pack-antes]');
          if (s0) s0.textContent = formatear(actual.price * cant, moneda);
        });
        var ok = !!actual.available;
        if (boton) { boton.disabled = !ok; var s2 = boton.querySelector('span'); if (s2) s2.textContent = ok ? boton.getAttribute('data-dn-texto') : boton.getAttribute('data-dn-agotado'); }
        if (botonBarra) botonBarra.disabled = !ok;
        raiz.querySelectorAll('[data-dn-al-carrito]').forEach(function (b) { b.disabled = !ok; });
      }
      function elegirVariante() {
        var sel = Array.prototype.map.call(raiz.querySelectorAll('[data-dn-opcion]'), function (o) { var m = o.querySelector('input:checked'); return m ? m.value : null; });
        var v = variantes.find(function (x) { return x.options.every(function (val, i) { return val === sel[i]; }); });
        if (!v) return;
        actual = v;
        if (inputId) inputId.value = v.id;
        raiz.querySelectorAll('[data-dn-opcion]').forEach(function (o, i) {
          var t = o.previousElementSibling && o.previousElementSibling.querySelector('[data-dn-opcion-texto]');
          if (t && sel[i]) t.textContent = sel[i].charAt(0) + sel[i].slice(1).toLowerCase();
        });
        if (carrusel) {
          var idx = -1;
          carrusel.fotos.forEach(function (f, i) { if (idx < 0 && sel.indexOf(f.getAttribute('data-dn-color')) > -1) idx = i; });
          if (idx > -1) carrusel.ir(idx);
        }
        try { var url = new URL(window.location.href); url.searchParams.set('variant', v.id); window.history.replaceState({}, '', url.toString()); } catch (e) { /* nada */ }
        pintar();
      }
      raiz.querySelectorAll('[data-dn-opcion] input').forEach(function (i) { i.addEventListener('change', elegirVariante); });
      raiz.querySelectorAll('[data-dn-packs] input').forEach(function (i) { i.addEventListener('change', pintar); });
      pintar();

      /* Barra fija: se ve siempre que el botón principal no esté en pantalla, tanto
         antes de llegar a él como después de pasarlo; se esconde solo mientras está a la
         vista. Antes salía solo al pasarlo, y en el celular el botón queda debajo de la
         galería, a unas dos pantallas: el primer pantallazo no tenía «Comprar». En
         escritorio pasaba lo mismo con pantallas bajas. Pedido de Santiago, 27-09-2026. */
      var barra = raiz.querySelector('[data-dn-barra]');
      if (barra && boton && 'IntersectionObserver' in window) {
        new IntersectionObserver(function (es) {
          es.forEach(function (e) {
            var mostrar = !e.isIntersecting;
            barra.classList.toggle('visible', mostrar);
            barra.setAttribute('aria-hidden', mostrar ? 'false' : 'true');
            var b = barra.querySelector('button'); if (b) b.tabIndex = mostrar ? 0 : -1;
          });
        }).observe(boton);
      }

      /* Hoja de compra rápida: sus controles son espejo de los del bloque de compra.
         Al tocar uno de la hoja se marca el de arriba (y viceversa), y se envía el mismo formulario. */
      var hoja = raiz.querySelector('[data-dn-hoja]');
      var totalHoja = raiz.querySelector('[data-dn-total-hoja]');
      var botonHoja = raiz.querySelector('[data-dn-comprar-hoja]');
      if (hoja) {
        var abrir = raiz.querySelector('[data-dn-abrir-hoja]');
        var cerrar = hoja.querySelector('[data-dn-cerrar-hoja]');
        var sincronizarHoja = function () {
          raiz.querySelectorAll('[data-dn-opcion]').forEach(function (o, i) {
            var m = o.querySelector('input:checked');
            var espejo = hoja.querySelector('[data-dn-espejo-opcion="' + i + '"]');
            if (m && espejo) espejo.querySelectorAll('input').forEach(function (x) { x.checked = x.value === m.value; });
          });
          var p = raiz.querySelector('[data-dn-packs] input:checked');
          if (p) hoja.querySelectorAll('[data-dn-espejo-packs] input').forEach(function (x) { x.checked = x.value === p.value; });
          if (totalHoja && total) totalHoja.textContent = total.textContent;
          if (botonHoja && boton) botonHoja.disabled = boton.disabled;
        };
        if (abrir) abrir.addEventListener('click', function () {
          sincronizarHoja();
          if (typeof hoja.showModal === 'function') hoja.showModal(); else hoja.setAttribute('open', '');
        });
        if (cerrar) cerrar.addEventListener('click', function () { if (hoja.close) hoja.close(); else hoja.removeAttribute('open'); });
        hoja.addEventListener('click', function (e) { if (e.target === hoja && hoja.close) hoja.close(); });
        hoja.querySelectorAll('[data-dn-espejo-opcion] input').forEach(function (x) {
          x.addEventListener('change', function () {
            var i = x.closest('[data-dn-espejo-opcion]').getAttribute('data-dn-espejo-opcion');
            var grupo = raiz.querySelectorAll('[data-dn-opcion]')[parseInt(i, 10)];
            var destino = grupo && Array.prototype.find.call(grupo.querySelectorAll('input'), function (y) { return y.value === x.value; });
            if (destino) { destino.checked = true; destino.dispatchEvent(new Event('change', { bubbles: true })); }
            sincronizarHoja();
          });
        });
        hoja.querySelectorAll('[data-dn-espejo-packs] input').forEach(function (x) {
          x.addEventListener('change', function () {
            var destino = Array.prototype.find.call(raiz.querySelectorAll('[data-dn-packs] input'), function (y) { return y.value === x.value; });
            if (destino) { destino.checked = true; destino.dispatchEvent(new Event('change', { bubbles: true })); }
            sincronizarHoja();
          });
        });
      }

      /* Añadir al carrito sin ir al pago (30-09-2026, pedido de Santiago: «un botón extra que permita
         añadir a la cesta y dejar el otro de comprar ya»). Manda el mismo formulario a /cart/add, sin el
         return_to que lleva al pago, y abre el carrito lateral de Dawn como lo hace su product-form.
         Sin carrito lateral (tema en modo página), lleva a /cart. */
      raiz.querySelectorAll('[data-dn-al-carrito]').forEach(function (b) {
        var texto = b.querySelector('span');
        var avisar = function (msg, ms) {
          if (!texto) return;
          texto.textContent = msg;
          setTimeout(function () { texto.textContent = b.getAttribute('data-dn-texto'); }, ms);
        };
        b.addEventListener('click', function () {
          if (!actual || !actual.available || b.getAttribute('aria-busy') === 'true') return;
          var cajon = document.querySelector('cart-drawer');
          var fd = new FormData(form);
          fd.delete('return_to');
          if (cajon && cajon.getSectionsToRender) {
            fd.append('sections', cajon.getSectionsToRender().map(function (s) { return s.id; }));
            fd.append('sections_url', window.location.pathname);
          }
          b.setAttribute('aria-busy', 'true');
          fetch((window.routes && window.routes.cart_add_url) || '/cart/add', {
            method: 'POST',
            headers: { Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
            body: fd
          })
            .then(function (r) { return r.json(); })
            .then(function (j) {
              if (j.status) throw new Error(j.description || j.message || 'No se pudo añadir');
              if (hoja && hoja.open && hoja.close) hoja.close();
              if (cajon && cajon.renderContents && j.sections) {
                if (cajon.setActiveElement) cajon.setActiveElement(b);
                cajon.classList.remove('is-empty');
                cajon.renderContents(j);
                avisar('✓ Añadido', 2200);
              } else {
                window.location = (window.routes && window.routes.cart_url) || '/cart';
              }
            })
            .catch(function (err) { avisar(err && err.message && err.message !== 'Failed to fetch' ? err.message : 'No se pudo añadir. Intenta de nuevo', 3500); })
            .then(function () { b.removeAttribute('aria-busy'); });
        });
      });

      /* Formulario contra entrega (snippets/dn-pedido.liquid, 30-09-2026). Pide sin pasar por el
         checkout: lo manda a doxnetworks.com/api/pedido, que crea el pedido en Shopify. */
      var pedido = raiz.querySelector('[data-dn-pedido]');
      if (pedido) {
        var pf = pedido.querySelector('[data-dn-pedido-form]');
        var pOk = pedido.querySelector('[data-dn-pedido-ok]');
        var pErr = pedido.querySelector('[data-dn-pedido-error]');
        var pEnviar = pedido.querySelector('[data-dn-pedido-enviar]');
        var abiertoEn = 0;
        var clave = 'dn:atribucion';
        var atribucion = function () {
          var sale = new URLSearchParams();
          new URLSearchParams(window.location.search).forEach(function (v, k) { if (k.indexOf('utm_') === 0 || k === 'fbclid' || k === 'gclid') sale.set(k, v); });
          var s = sale.toString();
          try { if (s) sessionStorage.setItem(clave, s); return sessionStorage.getItem(clave) || ''; } catch (e) { return s; }
        };
        atribucion();
        var linea = function () {
          var p = pack();
          var nombre = pedido.getAttribute('data-dn-titulo') || '';
          var opcion = actual && actual.title && actual.title !== 'Default Title' ? ' (' + actual.title.charAt(0) + actual.title.slice(1).toLowerCase() + ')' : '';
          return { variante: String(actual.id), cantidad: p.cant, total: Math.round((actual.price * p.cant - p.desc) / 100), resumen: p.cant + ' × ' + nombre + opcion };
        };
        var pesos = function (n) { return formatear(n * 100, moneda); };
        /* Píxel de Meta (05-10-2026): el de la app de Shopify corre en la página (window.fbq, mismo ID que
           doxnetworks.com), así que se le mandan los mismos eventos que en el formulario de doxnetworks.com:
           InitiateCheckout al abrir y Purchase al confirmar, con eventID «pedido-<id>», el mismo que manda el
           Worker por la API de conversiones, para que Meta cuente la compra una sola vez. */
        var pixel = function (evento, datos, opciones) {
          try { if (typeof window.fbq === 'function') { if (opciones) window.fbq('track', evento, datos, opciones); else window.fbq('track', evento, datos); } } catch (e) { /* nada */ }
        };
        var datosPixel = function (l) {
          return { content_ids: [l.variante], content_type: 'product', content_name: pedido.getAttribute('data-dn-titulo') || '', value: l.total, num_items: l.cantidad, currency: 'COP' };
        };
        var cerrarPedido = function () {
          if (pedido.close) pedido.close(); else pedido.removeAttribute('open');
          if (!pOk.hidden) { pOk.hidden = true; pf.hidden = false; ['ciudad', 'direccion', 'barrio'].forEach(function (k) { pf.elements[k].value = ''; }); }
        };
        var abrirPedido = function () {
          if (!actual || !actual.available) return;
          if (hoja && hoja.open && hoja.close) hoja.close();
          var l = linea();
          pedido.querySelector('[data-dn-pedido-total]').textContent = pesos(l.total);
          pedido.querySelector('[data-dn-pedido-resumen]').textContent = l.resumen + ' · envío gratis';
          pEnviar.querySelector('span').textContent = 'Confirmar pedido · ' + pesos(l.total);
          pOk.hidden = true; pf.hidden = false; pErr.hidden = true;
          abiertoEn = Date.now();
          pixel('InitiateCheckout', datosPixel(l));
          if (typeof pedido.showModal === 'function') pedido.showModal(); else pedido.setAttribute('open', '');
        };
        raiz.querySelectorAll('[data-dn-abrir-pedido]').forEach(function (b) { b.addEventListener('click', abrirPedido); });
        pedido.querySelectorAll('[data-dn-pedido-cerrar]').forEach(function (b) { b.addEventListener('click', cerrarPedido); });
        pedido.addEventListener('click', function (e) { if (e.target === pedido) cerrarPedido(); });
        var alterno = pedido.querySelector('[data-dn-pedido-alterno]');
        if (alterno) alterno.addEventListener('click', function () {
          cerrarPedido();
          if (form.requestSubmit) form.requestSubmit(); else form.submit();
        });

        var limpiar = function (s) { return String(s || '').replace(/\D/g, '').replace(/^57(?=3\d{9}$)/, ''); };
        var galleta = function (n) { var m = document.cookie.match(new RegExp('(?:^|; )' + n + '=([^;]*)')); return m ? m[1] : ''; };
        var reglas = {
          nombre: function (v) { return v.trim().split(/\s+/).filter(function (x) { return x.length >= 2; }).length >= 2 ? '' : 'Escribe tu nombre y apellido.'; },
          celular: function (v) { return /^3\d{9}$/.test(limpiar(v)) ? '' : '10 dígitos, empezando por 3.'; },
          departamento: function (v) { return v ? '' : 'Elige tu departamento.'; },
          ciudad: function (v) { return v.trim().length >= 3 ? '' : 'Escribe tu ciudad o municipio.'; },
          direccion: function (v) { return v.trim().length >= 6 ? '' : 'Escribe la dirección completa.'; }
        };
        pf.addEventListener('submit', function (e) {
          e.preventDefault();
          var primero = null;
          Object.keys(reglas).forEach(function (k) {
            var campo = pf.elements[k];
            var msg = reglas[k](campo.value);
            var caja = campo.closest('.dn-campo');
            var err = caja && caja.querySelector('.dn-campo__error');
            if (caja) caja.classList.toggle('dn-campo--error', !!msg);
            campo.setAttribute('aria-invalid', msg ? 'true' : 'false');
            if (err) { err.textContent = msg; err.hidden = !msg; }
            if (msg && !primero) primero = campo;
          });
          if (primero) { primero.focus(); return; }
          var l = linea();
          var d = {
            nombre: pf.elements.nombre.value, celular: limpiar(pf.elements.celular.value), departamento: pf.elements.departamento.value,
            ciudad: pf.elements.ciudad.value, direccion: pf.elements.direccion.value, barrio: pf.elements.barrio.value, web: pf.elements.web.value,
            variante: l.variante, cantidad: l.cantidad, total: l.total, atribucion: atribucion(), pagina: window.location.pathname, ms: Date.now() - abiertoEn,
            /* Cookies del píxel de Meta: el Worker manda la compra por la API de conversiones (worker/capi.ts). */
            fbp: galleta('_fbp'), fbc: galleta('_fbc')
          };
          pEnviar.disabled = true;
          pEnviar.querySelector('span').textContent = 'Enviando tu pedido…';
          pErr.hidden = true;
          fetch(pedido.getAttribute('data-dn-api'), { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(d) })
            .then(function (r) {
              return r.json().catch(function () { return {}; }).then(function (j) {
                if (!r.ok || !j.ok) throw new Error(j.error || 'No pudimos registrar el pedido.');
                return j;
              });
            })
            .then(function (j) {
              pf.hidden = true;
              pOk.hidden = false;
              pedido.querySelector('[data-dn-pedido-ok-titulo]').textContent = '¡Pedido recibido, ' + d.nombre.trim().split(/\s+/)[0] + '!';
              pedido.querySelector('[data-dn-pedido-numero]').textContent = j.pedido ? 'Pedido ' + j.pedido : '';
              pedido.querySelector('[data-dn-pedido-ok-texto]').textContent = 'Te escribimos por WhatsApp al ' + d.celular + ' para confirmar la dirección antes de despacharlo. Le pagas ' + pesos(l.total) + ' al mensajero cuando te llegue.';
              pixel('Purchase', datosPixel(l), { eventID: 'pedido-' + (j.id || j.pedido) });
              try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish('dn_pedido_contraentrega', { pedido: j.pedido, valor: l.total, moneda: 'COP', variante: l.variante, cantidad: l.cantidad }); } catch (e2) { /* nada */ }
            })
            .catch(function (err) {
              var msg = err && err.message && err.message !== 'Failed to fetch' ? err.message : 'No pudimos registrar el pedido. Revisa tu conexión.';
              pErr.querySelector('p').textContent = msg;
              var texto = 'Hola, quiero pedir contra entrega: ' + l.resumen + ', ' + pesos(l.total) + '. Nombre: ' + d.nombre + '. Celular: ' + d.celular + '. Dirección: ' + d.direccion + (d.barrio ? ', ' + d.barrio : '') + ', ' + d.ciudad + '.';
              pErr.querySelector('a').href = 'https://wa.me/' + (pedido.getAttribute('data-dn-wa') || '573189819384') + '?text=' + encodeURIComponent(texto);
              pErr.hidden = false;
            })
            .then(function () {
              pEnviar.disabled = false;
              pEnviar.querySelector('span').textContent = 'Confirmar pedido · ' + pesos(l.total);
            });
        });
      }

      /* Entrega estimada en días hábiles (lunes a viernes, sin festivos). */
      var entrega = raiz.querySelector('[data-dn-entrega]');
      if (entrega) {
        var min = parseInt(entrega.getAttribute('data-dn-min'), 10) || 3;
        var max = parseInt(entrega.getAttribute('data-dn-max'), 10) || 6;
        var festivos = (entrega.getAttribute('data-dn-festivos') || '').split(',').map(function (s) { return s.trim(); });
        var clave = function (d) { return d.getFullYear() + '-' + String(d.getMonth() + 1).padStart(2, '0') + '-' + String(d.getDate()).padStart(2, '0'); };
        var habil = function (d) { var w = d.getDay(); return w !== 0 && w !== 6 && festivos.indexOf(clave(d)) < 0; };
        var sumar = function (n) { var d = new Date(); d.setHours(12, 0, 0, 0); var c = 0; while (c < n) { d.setDate(d.getDate() + 1); if (habil(d)) c++; } return d; };
        try {
          var f = new Intl.DateTimeFormat('es-CO', { weekday: 'short', day: 'numeric', month: 'short' });
          var t = entrega.querySelector('[data-dn-entrega-texto]');
          if (t) t.innerHTML = 'Pide hoy y te llega entre el <b>' + f.format(sumar(min)).replace(/\./g, '') + '</b> y el <b>' + f.format(sumar(max)).replace(/\./g, '') + '</b>';
          /* Paso 3 de la línea de entrega: «lun 5 – jue 8 oct» (o «mié 30 sep – vie 2 oct»). */
          var rango = entrega.querySelector('[data-dn-entrega-rango]');
          if (rango) {
            var partes = function (d) {
              var o = {};
              f.formatToParts(d).forEach(function (p) { o[p.type] = p.value.replace(/\./g, ''); });
              return o;
            };
            var a = partes(sumar(min)), b = partes(sumar(max));
            rango.textContent = a.month === b.month
              ? a.weekday + ' ' + a.day + ' – ' + b.weekday + ' ' + b.day + ' ' + b.month
              : a.weekday + ' ' + a.day + ' ' + a.month + ' – ' + b.weekday + ' ' + b.day + ' ' + b.month;
          }
        } catch (e) { /* queda el texto de respaldo */ }
      }
    });
  }

  /* Descuento por pago adelantado con reloj por visitante.
     - El reloj arranca en la primera visita y se guarda en este navegador: si vuelve, sigue bajando.
     - Al llegar a cero el bloque desaparece. A los 7 días del inicio, la persona recibe una oferta nueva.
     - El código es PREFIJO + DDMM del día (hora de Bogotá) de esa primera visita. Shopify lo acepta de las
       00:00 de ese día a las 02:00 del siguiente, así que tampoco vale copiado días después.
     - Fuera del rango desde–hasta (los días con código creado) no sale nada. */
  function initPrepago() {
    var bloques = document.querySelectorAll('[data-dn-prepago]');
    if (!bloques.length) return;
    var b0 = bloques[0];
    var horas = parseFloat(b0.getAttribute('data-dn-horas')) || 2;
    var prefijo = b0.getAttribute('data-dn-prefijo') || 'PAGOYA';
    var desde = b0.getAttribute('data-dn-desde') || '';
    var hasta = b0.getAttribute('data-dn-hasta') || '';
    var CLAVE = 'dn-prepago-inicio', RENUEVA = 7 * 864e5;
    var ahora = Date.now(), inicio = null;
    try { inicio = parseInt(window.localStorage.getItem(CLAVE), 10) || null; } catch (e) { /* sin almacenamiento: cuenta desde esta carga */ }
    if (!inicio || inicio > ahora || ahora - inicio > RENUEVA) {
      inicio = ahora;
      try { window.localStorage.setItem(CLAVE, String(inicio)); } catch (e) {}
    }
    var fin = inicio + horas * 36e5;
    var dia;
    try {
      dia = new Intl.DateTimeFormat('en-CA', { timeZone: 'America/Bogota', year: 'numeric', month: '2-digit', day: '2-digit' }).format(new Date(inicio));
    } catch (e) { return; }
    if ((desde && dia < desde) || (hasta && dia > hasta) || ahora >= fin) return;
    var codigo = prefijo + dia.slice(8, 10) + dia.slice(5, 7);

    var todos = Array.prototype.slice.call(bloques).concat(Array.prototype.slice.call(document.querySelectorAll('[data-dn-prepago-mini]')));
    todos.forEach(function (b) {
      b.querySelectorAll('[data-dn-codigo]').forEach(function (c) { c.textContent = codigo; });
      b.hidden = false;
    });

    bloques.forEach(function (b) {
      var boton = b.querySelector('[data-dn-copiar]');
      var txt = b.querySelector('[data-dn-copiar-texto]');
      if (!boton) return;
      boton.addEventListener('click', function () {
        var listo = function () {
          if (!txt) return;
          txt.textContent = '¡Copiado!';
          setTimeout(function () { txt.textContent = 'Copiar'; }, 1800);
        };
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(codigo).then(listo, function () {});
        } else {
          try {
            var r = document.createRange();
            r.selectNodeContents(boton.querySelector('[data-dn-codigo]'));
            var s = window.getSelection(); s.removeAllRanges(); s.addRange(r);
            document.execCommand('copy'); listo();
          } catch (e) {}
        }
      });
    });

    var relojes = [];
    todos.forEach(function (b) { b.querySelectorAll('[data-dn-reloj]').forEach(function (x) { relojes.push(x); }); });
    var dos = function (n) { return String(n).padStart(2, '0'); };
    (function tic() {
      var r = fin - Date.now();
      if (r <= 0) { todos.forEach(function (b) { b.hidden = true; }); return; }
      var s = Math.floor(r / 1000);
      var t = Math.floor(s / 3600) + ':' + dos(Math.floor((s % 3600) / 60)) + ':' + dos(s % 60);
      relojes.forEach(function (x) { x.textContent = t; });
      setTimeout(tic, 1000 - (Date.now() % 1000) + 5);
    })();
  }

  /* Cifras que cuentan al aparecer (solo números; "3,2" usa coma decimal). */
  function initContadores() {
    var nodos = document.querySelectorAll('[data-dn-contar]');
    if (!nodos.length || reducir || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (!e.isIntersecting) return;
        io.unobserve(e.target);
        var txt = e.target.getAttribute('data-dn-contar');
        var m = txt.match(/^([^\d]*)(\d+(?:[.,]\d+)?)(.*)$/);
        if (!m) return;
        var dec = (m[2].split(/[.,]/)[1] || '').length;
        var fin = parseFloat(m[2].replace(',', '.'));
        if (!fin) return;
        var t0 = null;
        function paso(ts) {
          if (!t0) t0 = ts;
          var p = Math.min(1, (ts - t0) / 1100);
          var v = fin * (1 - Math.pow(1 - p, 3));
          e.target.textContent = m[1] + v.toFixed(dec).replace('.', ',') + m[3];
          if (p < 1) window.requestAnimationFrame(paso); else e.target.textContent = txt;
        }
        window.requestAnimationFrame(paso);
      });
    }, { threshold: 0.4 });
    nodos.forEach(function (n) { io.observe(n); });
  }

  /* Vídeos con voz: corren solos en silencio (initBucles); al tocar uno, arranca desde el
     principio con sonido y controles, y los demás se callan. */
  function initVideos() {
    var marcos = document.querySelectorAll('[data-dn-video]');
    marcos.forEach(function (m) {
      var v = m.querySelector('video');
      if (!v) return;
      m.addEventListener('click', function (e) {
        if (m.classList.contains('con-sonido')) return;
        e.preventDefault();
        document.querySelectorAll('[data-dn-video]').forEach(function (o) {
          if (o === m) return;
          var ov = o.querySelector('video');
          if (ov) { ov.muted = true; ov.controls = false; }
          o.classList.remove('con-sonido');
        });
        v.removeAttribute('data-dn-bucle');
        v.muted = false; v.loop = false; v.controls = true; v.currentTime = 0;
        m.classList.add('con-sonido');
        var p = v.play(); if (p && p.catch) p.catch(function () {});
      });
    });
  }

  /* Calculadora de días: capacidad en gramos (rango) dividida por la ración diaria. */
  function initCalculadora() {
    document.querySelectorAll('[data-dn-calc]').forEach(function (c) {
      var gmin = parseFloat(c.getAttribute('data-dn-gmin')) || 1000;
      var gmax = parseFloat(c.getAttribute('data-dn-gmax')) || 1400;
      var rango = c.querySelector('[data-dn-gramos-rango]');
      var texto = c.querySelector('[data-dn-gramos-texto]');
      var dias = c.querySelector('[data-dn-dias]');
      var barra = c.querySelector('[data-dn-dias-barra]');
      var presets = c.querySelectorAll('[data-dn-gramos]');
      if (!rango || !dias) return;
      function pintar() {
        var g = Math.max(1, parseFloat(rango.value) || 1);
        var a = Math.floor(gmin / g), b = Math.floor(gmax / g);
        if (texto) texto.textContent = g + ' g';
        dias.textContent = a === b ? String(a) : a + '–' + b;
        if (barra) barra.style.width = Math.min(100, (b / 30) * 100) + '%';
        presets.forEach(function (p) { p.classList.toggle('activo', parseFloat(p.getAttribute('data-dn-gramos')) === g); });
      }
      presets.forEach(function (p) {
        p.addEventListener('click', function () { rango.value = p.getAttribute('data-dn-gramos'); pintar(); });
      });
      rango.addEventListener('input', pintar);
      pintar();
    });
  }

  /* Bucles mudos: arrancan al verse y se pausan al salir. */
  function initBucles() {
    var vs = document.querySelectorAll('video[data-dn-bucle]');
    if (!vs.length || reducir || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        var v = e.target;
        if (!v.hasAttribute('data-dn-bucle')) { if (!e.isIntersecting) v.pause(); return; }
        if (e.isIntersecting) { v.preload = 'auto'; v.muted = true; var p = v.play(); if (p && p.catch) p.catch(function () {}); } else { v.pause(); }
      });
    }, { threshold: 0.35 });
    vs.forEach(function (v) { io.observe(v); });
  }

  function init() { initReveals(); initOferta(); initPrepago(); initContadores(); initVideos(); initBucles(); initCalculadora(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
